exports = module.exports = require("./../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".inp-mandaat{position:relative;-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1;display:-webkit-box;display:-ms-flexbox;display:flex}.ref-select{position:absolute;z-index:20;top:100%;left:-3px;margin-top:3px;min-width:calc(100% + 6px);background-color:#f3f3f3;color:#000;white-space:normal}.ref-option{padding:0 10px;white-space:nowrap;line-height:34px;height:34px}.ref-ghost{background-color:#e6e6e6}.staggered-transition{-webkit-transition:opacity .5s ease,height .5s ease;transition:opacity .5s ease,height .5s ease;overflow:hidden}.staggered-enter,.staggered-leave{opacity:0;height:0}", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./~/vue-loader/lib/style-rewriter.js!./~/vue-loader/lib/selector.js?type=style&index=0!./src/components/InputPerson.vue
 ** module id = 123
 ** module chunks = 0
 **/